<template>
    <div class="main-forgot-pass-container">
        <div class="forgot-pass-container">
            <div class="forgot-pass-area stick-it">
                <div class="forgot-pass-area-content">
                    <h1>Reset Password</h1>
                    <p> Enter your email address and we will send you instructions to rest your password
                        <i class="em em-old_key"></i>
                    </p>
                    <input type="text" placeholder="Registered Email"/>
                    <button type="button" class="btn-forgot-pass" @click="sendResetPasswordEmail">Reset</button>
                    <label class="no-account-label">
                        <router-link to="/" class="click-register-label"> Go to Home page </router-link>

                    </label>
                </div>
            </div>
            <div class="forgot-pass-showcase-area">                    
                <agile :arrows="false" :speed="500" :autoplaySpeed = "7000"
                       :timing="'linear'" :fade="false"
                       :autoplay="true" :pauseOnHover="true">
                    <div class="slide slide--1">
                        <div class="slide-content">
                            <h1>AUGMENTED REALITY FOR INSTALLATION</h1>
                            <p>The first ever AR application for onsite layout planner use by pioneer and innovative companies</p>
                        </div>
                    </div>

                    <div class="slide slide--2">
                        <div class="slide-content">
                            <h1>THE USE OF AR TECHNOLOGY FOR MAINTENANCE</h1>
                            <p>Modern innovative tool to completely digitalize and contextualize models of the whole site with the ability to edit and share contextual notes</p>
                        </div>
                    </div>

                    <div class="slide slide--3">
                        <div class="slide-content">
                            <h1>DEMONSTRATION OF PRODUCTS TO CUSTOMERS</h1>
                            <p>An effective sales tool to mesmerize end-users with your products</p>
                        </div>
                    </div>
                </agile>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "ForgotPassword",
        data: function () {
            return {
                image: require('@/assets/images/img-vr.png')
            }
        },
        methods: {
            sendResetPasswordEmail: function () {
                console.log("register clicked!")
            }
        }
    }
</script>

<style  lang="scss" scoped>

    @import "@/assets/css/colors.scss";

    %flex-center-content {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .stick-it {
        position: sticky;
        position: -webkit-sticky;
        top: 0px;
    }

    .main-forgot-pass-container{
        width: 100%;
        height: 100%;
        background: #fff url('http://i.picpar.com/ztld.png') no-repeat 50% 50%;
        background-size: cover;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .forgot-pass-container {
        width: 95%;
        height: 90%;
        top: 0;
        box-shadow: 0 0 30px 0 black;
        margin: 0;
        padding: 0;
        display: grid;
        background-color: transparent;
        grid-template-areas: "forgot-pass--form forgot-pass--showcase";
        grid-template-rows: 1fr;
        // grid-template-rows: repeat(1, 100vh);
        grid-template-columns: 40% 60%;
        overflow: hidden;
    }

    .forgot-pass-area {
        grid-area: forgot-pass--form;
        width: 100%;
        height: 100vh;
        background-color: white;
        margin: auto;
        padding: 0;
        @extend %flex-center-content;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        overflow: hidden;
    }

    .forgot-pass-area .forgot-pass-area-content {
        background-color: white;
        width: 90%;
        padding: 0 10% 20% 10%;
        height: auto;
        display: table-cell;
        vertical-align: middle;
        border-radius: 20px;
    }

    .forgot-pass-area-content input[type=text], input[type=password] {
        width: 100%;
        border: 1px solid #aaa;
        // border-radius: 15px;
        margin: 3% 0;
        outline: none;
        padding: 4%;
        box-sizing: border-box;
        transition: 0.3s;
        font-family: 'Roboto', sans-serif;
        font-size: 120%;
        letter-spacing: 1px;
    }

    .forgot-pass-area-content input[type=text]:focus, input[type=password]:focus {
        font-family: 'Roboto', sans-serif;
        border-color: $primary-color;
        box-shadow: 0 0 5px 0 $primary-color;
        // font-size: 120%;
    }

    .forgot-pass-area-content input[type=checkbox] {
        position: relative;
        width: 20px;
        height: 20px;
        margin-right: 2%;
        -moz-appearance: none;
        -ms-progress-appearance: unset;
        -webkit-appearance: none;
        outline: none;
        transition: .3s;
        cursor: pointer;
    }

    .forgot-pass-area-content input[type=checkbox]:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 2px solid #aaa;
        box-sizing: border-box;
        transition: .3s;
    }

    .forgot-pass-area-content input:checked[type=checkbox]:before {
        border-left: none;
        border-top: none;
        width: 40%;
        border-color: $primary-color;
        transform: rotate(45deg) translate(15%, -20%);
    }

    .forgot-pass-area-content .btn-forgot-pass {
        width: 100%;
        // border-radius: 15px;
        margin: 5% 0;
        outline: none;
        padding: 4%;
        box-sizing: border-box;
        transition: 0.3s;
        font-family: 'Roboto', sans-serif;
        font-size: 120%;
        color: white;
        font-weight: bolder;
        background: $primary-color;
        /*background: linear-gradient(90deg, blueviolet, #e281da);*/
        clear: both;
        float: left;
        cursor: pointer;
        border: none;
    }

    .forgot-pass-area-content .no-account-label {
        clear: both;
        float: left;
        width: 100%;
        text-align: center;
        color: #545454;
        font-family: 'Roboto', sans-serif;
        font-size: 100%;
        margin: 8% 0;
        letter-spacing: 1px;
        /*vertical-align: middle;*/
    }

    .forgot-pass-area-content .click-register-label {
        color: $primary-color;
        font-family: 'Roboto', sans-serif;
        font-weight: bold;
        text-decoration: none;
    }

    .forgot-pass-area-content .click-register-label:hover {
        text-decoration: underline;
    }

    .forgot-pass-area img {
        width: 150%;
        height: auto;
        opacity: 0.15;
        position: absolute;
        margin-left: 5%;
        min-width: 100%;
         -webkit-transition: all 5s ease; /* Safari and Chrome */
         -moz-transition: all 5s ease; /* Firefox */
         -o-transition: all 5s ease; /* IE 9 */
         -ms-transition: all 5s ease; /* Opera */
        transition: all 5s ease;
    }

    .forgot-pass-area:hover img {
         -webkit-transform: scale(1.10); /* Safari and Chrome */
         -moz-transform: scale(1.10); /* Firefox */
         -ms-transform: scale(1.10); /* IE 9 */
         -o-transform: scale(1.10); /* Opera */
        transform: scale(1.10);
    }

    .forgot-pass-area h1 {
        color: $primary-color;
        font-family: 'Roboto Slab', sans-serif;
        font-size: 300%;
        width: 100%;
        margin: 10% 0 2% 0;
        text-align: left;
    }

    .forgot-pass-area p {
        color: #545454;
        font-family: 'Roboto', sans-serif;
        font-size: 120%;
        margin: 2% 0 5% 0;
        line-height: 150%;
        font-weight: lighter;
        text-align: left;
    }

    .forgot-pass-showcase-area {
        grid-area: forgot-pass--showcase;
        width: 100%;
        height: 100%;
        margin: auto;
        top: 0;
        padding: 0;
        background-color: transparent;

    }

    .slide {
        height: 90vh;
        display: flex;
        align-items: center;
        padding: 1%;

        .slide-content{
            h1{
                font-family: 'Roboto', sans-serif;
                font-size: 200%;
                width: 100%;
                margin-bottom: 2%;
                color: white;
                text-align: left;
                font-weight: bolder;
            }

            p{
                font-family: 'Roboto Slab', sans-serif;
                font-size: 120%;
                margin: 2% 0 5% 0;
                line-height: 150%;
                font-weight: lighter;
                color: white;
                text-align: left;
            }
        }
        &:before {
            background: transparent;
            content: '';
            height: 100%;
            left: 0;
            position: absolute;
            top: 0;
            width: 100%;
        }

        &--1 {
            background: transparent;
        }

        &--2 {
            background: transparent;
        }

        &--3 {
            background: transparent;
        }
    }

</style>